const OPEN_METEO_FORECAST_URL = "https://api.open-meteo.com/v1/forecast";

const toNumberOrNull = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
};

export const getPublicWeather = async ({
  latitude,
  longitude,
  signal,
} = {}) => {
  const lat = toNumberOrNull(latitude);
  const lon = toNumberOrNull(longitude);

  if (lat === null || lon === null) {
    throw new Error("Coordonnées météo invalides.");
  }

  const params = new URLSearchParams({
    latitude: String(lat),
    longitude: String(lon),
    current:
      "temperature_2m,relative_humidity_2m,apparent_temperature,is_day,precipitation,rain,showers,weather_code,cloud_cover,wind_speed_10m,wind_gusts_10m",
    daily: "temperature_2m_max,temperature_2m_min,precipitation_sum",
    forecast_days: "1",
    timezone: "Europe/Paris",
  });

  const response = await fetch(`${OPEN_METEO_FORECAST_URL}?${params}`, {
    method: "GET",
    signal,
  });

  if (!response.ok) {
    throw new Error("Impossible de récupérer la météo.");
  }

  return response.json();
};